import { render, staticRenderFns } from "./DropifyUploader.vue?vue&type=template&id=5bf0e2bd"
import script from "./DropifyUploader.vue?vue&type=script&lang=js"
export * from "./DropifyUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports